import m from "./../../../dist/es2015/locales/da_DK.js";
export const am5locales_da_DK = m;